import { CustomerInfo } from '@revenuecat/purchases-capacitor';
import { AppActionType, AppActions } from './actions';

export interface AppState {
  revenueCatCustomer?: CustomerInfo;
  upgradeDialogVisible: boolean;
}

export const getInitialState = (): AppState => ({
  revenueCatCustomer: undefined,
  upgradeDialogVisible: false,
});

export const AppReducer = (state: AppState, action: AppActions): AppState => {
  switch (action.type) {
    case AppActionType.SET_REVENUECAT_CUSTOMER:
      return {
        ...state,
        revenueCatCustomer: action.payload,
      };
    case AppActionType.SET_UPGRADE_DIALOG_VISIBLE:
      return {
        ...state,
        upgradeDialogVisible: action.payload,
      };
    default:
      return state;
  }
};
